import { styled } from '@mui/material';
import previewPlaceholder from './resources/previewPlaceholder.svg';
import VideoJsPlayer from './video-js-player';

const VideoPlayerContainer = styled('div', { name: 'VideoPlayerContainer' })(({ theme }) => ({
	// display: 'flex',
	aspectRatio: '16 / 9',
	// flexDirection: 'column',
	// gap: theme.spacing(4),
	// mb: theme.spacing(6),
}));

const ImagePreview = styled('img', { name: 'ImagePreview' })(({ theme }) => ({
	// display: 'flex',
	aspectRatio: '16 / 9',
	objectFit: 'cover',
	// flexDirection: 'column',
	// gap: theme.spacing(4),
	// mb: theme.spacing(6),
}));

type VideoPlayerProps = {
	id: string;
	src: string;
};

// Faced with the problem that some videos did not play if the object {src, type} was transmitted in
// the sources array. Passing an array of strings solved the problem.
// sources: playURL ? [{ src: playURL, type: (file.meta && file.meta.type) || 'video/mp4' }] : null,
export default function VideoPlayer({ id, src, ...props }: VideoPlayerProps) {
	return (
		<VideoPlayerContainer>
			{src ? (
				<VideoJsPlayer id={id} sources={src ? [src] : null} {...props} />
			) : (
				<ImagePreview src={previewPlaceholder} alt="Preview placeholder" />
			)}
		</VideoPlayerContainer>
	);
}
